import React from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "./Logo";
import MythosLogo, { MYTHOS_URL } from "./MythosLogo";
import ProfilePill from "./ProfilePill";
import { MessageSquare, BookOpen, ListChecks, Map, Library, Home, Briefcase, BarChart3, Sun, Mail, Network, Swords, Compass, Sparkles } from "lucide-react";

const links = [
  { to: "/", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/immersive", label: "Immersive Lab", icon: Sparkles, testid: "nav-immersive" },
  { to: "/xr", label: "XR Worlds", icon: Compass, testid: "nav-xr" },
  { to: "/bharat-quest", label: "Bharat Quest", icon: Swords, testid: "nav-bharat-quest" },
  { to: "/today", label: "Today", icon: Sun, testid: "nav-today" },
  { to: "/chat", label: "Chat", icon: MessageSquare, testid: "nav-chat" },
  { to: "/stories", label: "Stories", icon: BookOpen, testid: "nav-stories" },
  { to: "/quiz", label: "Quiz", icon: ListChecks, testid: "nav-quiz" },
  { to: "/paths", label: "Paths", icon: Map, testid: "nav-paths" },
  { to: "/library", label: "Library", icon: Library, testid: "nav-library" },
  { to: "/careers", label: "Careers", icon: Briefcase, testid: "nav-careers" },
  { to: "/subscribe", label: "Subscribe", icon: Mail, testid: "nav-subscribe" },
  { to: "/impact", label: "Impact", icon: BarChart3, testid: "nav-impact" },
  { to: "/ecosystem", label: "Ecosystem", icon: Network, testid: "nav-ecosystem" },
];

export default function Header() {
  return (
    <header className="border-b border-[#DCD7CE] bg-[#F4F1EA]/85 backdrop-blur sticky top-0 z-30" data-testid="app-header">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4 px-5 md:px-10 py-4">
        <div className="flex items-center gap-3" data-testid="brand-block">
          <Link to="/" data-testid="brand-link" aria-label="EduSphere home">
            <Logo size={42} />
          </Link>
          <div className="leading-tight">
            <Link to="/" className="font-heading font-extrabold text-xl tracking-tight text-[#1A1A1A] hover:opacity-80 transition block">
              EduSphere
            </Link>
            <a
              href={MYTHOS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold hover:text-[#1A1A1A] transition"
              data-testid="header-mythos-link"
              title="Mythos India Studios — parent company"
            >
              <MythosLogo size={14} testid="header-mythos-logo" />
              by <span className="text-[#1A1A1A]">Mythos India Studios</span>
            </a>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
            {links.map(({ to, label, icon: Icon, testid }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 px-2.5 py-2 rounded-full text-sm font-medium transition-all ${
                    isActive ? "bg-[#E07A5F] text-white" : "text-[#1A1A1A] hover:bg-[#EBE7E0]"
                  }`
                }
              >
                <Icon size={14} />
                {label}
              </NavLink>
            ))}
          </nav>
          <ProfilePill />
        </div>
      </div>
      <nav className="lg:hidden flex overflow-x-auto thin-scroll gap-1 px-3 pb-3" data-testid="mobile-nav">
        {links.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={`m-${testid}`}
            className={({ isActive }) =>
              `whitespace-nowrap flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${
                isActive ? "bg-[#E07A5F] text-white" : "bg-white border border-[#DCD7CE] text-[#1A1A1A]"
              }`
            }
          >
            <Icon size={13} />
            {label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
